import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ size = "md", className = "" }) => {
  const dims = {
    sm: { mark: "h-7 w-7", text: "text-lg", dot: "h-1.5 w-1.5" },
    md: { mark: "h-9 w-9", text: "text-xl", dot: "h-2 w-2" },
    lg: { mark: "h-12 w-12", text: "text-2xl", dot: "h-2.5 w-2.5" },
  }[size];

  return (
    <Link
      to="/"
      data-testid="brand-logo-link"
      className={`group inline-flex items-center gap-3 ${className}`}
      aria-label="Genesis Appliance Repair"
    >
      <span
        className={`relative ${dims.mark} flex items-center justify-center rounded-2xl bg-[#082133] text-[#FAFAFA] font-display font-bold transition-transform duration-300 group-hover:rotate-[-6deg]`}
      >
        G
        <span
          className={`${dims.dot} absolute -top-0.5 -right-0.5 rounded-full bg-[#FAFAFA] ring-2 ring-[#082133]`}
        />
      </span>
      <span className="leading-tight">
        <span
          className={`block font-display font-semibold ${dims.text} text-[#111111] tracking-tight`}
        >
          Genesis
        </span>
        <span className="block text-[10px] uppercase tracking-[0.18em] text-[#4B5563] font-medium">
          Appliance Repair
        </span>
      </span>
    </Link>
  );
};

export default Logo;
